import getConfig from "next/config";
import { connect } from "react-redux";
import Link from "next/link";
import _get from "lodash/get";

import { addModal } from "@store/app/actions";
import Modal from "@components/Modal";
import Info from "@components/Icons/Info";
import ImageWithFallback from "@components/ImageWithFallback";

const {
  publicRuntimeConfig: {
    settings: { baseUrl, cdn, websiteStatics },
  },
} = getConfig();

const ProductBenefits = ({ benefits, addModal }) => (
  <ul className="space-y-[8px]">
    {benefits.map((benefit, index) => {
      const hasExternalURL = Boolean(benefit.external_url_key);
      const hasURLKey = Boolean(benefit.url_key);
      const hasModalContent =
        benefit.content && Object.keys(benefit.content).length !== 0;

      const infoType = hasExternalURL
        ? "externalURL"
        : hasURLKey
        ? "urlKey"
        : hasModalContent
        ? "modal"
        : null;

      return (
        <li key={index} className="flex items-center justify-between">
          <span className="flex justify-start items-center truncate">
            <ImageWithFallback
              src={benefit.image ? `${cdn}/${benefit.image}` : null}
              className="mr-[6px]"
              style={{ maxWidth: "20px", height: "auto" }}
              fallback={`${websiteStatics}/images/benefits-placeholder.svg`}
            />

            {benefit.title && (
              <span className="text-12px font-medium truncate">
                {benefit.title}
              </span>
            )}
          </span>

          {infoType === "externalURL" && (
            <Link href={`${baseUrl}/${benefit.external_url_key}`}>
              <a
                className="inline-block text-gray sm:hover:text-yellow-hover ml-1 w-5 h-5 rounded-full text-center align-middle"
                title=""
                target="_blank"
                rel="noopener noreferrer"
              >
                <Info />
              </a>
            </Link>
          )}

          {infoType === "urlKey" && (
            <Link href={`${baseUrl}/${benefit.url_key}/pag/`}>
              <a
                className="inline-block text-gray sm:hover:text-yellow-hover ml-10px w-5 h-5 rounded-full text-center align-middle"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Info />
              </a>
            </Link>
          )}

          {infoType === "modal" && (
            <>
              <button
                onClick={() => addModal(`benefitModal-${index}`)}
                className="inline-block text-gray sm:hover:text-yellow-hover ml-10px w-5 h-5 rounded-full text-center align-middle"
              >
                <Info />
              </button>

              <Modal
                position="right"
                header={benefit.title || ""}
                className="Confirmation-modal-container"
                id={`benefitModal-${index}`}
              >
                <div className="Confirmation-modal-children mb-6">
                  {_get(benefit, "content.cms_block_top.content", "") && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: benefit.content.cms_block_top.content,
                      }}
                    ></div>
                  )}

                  {_get(benefit, "content.cms_block_bottom.content", "") && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: benefit.content.cms_block_bottom.content,
                      }}
                    ></div>
                  )}
                </div>
              </Modal>
            </>
          )}
        </li>
      );
    })}
  </ul>
);

export default connect(null, {
  addModal,
})(ProductBenefits);
